const equalWidth = () => {
  let item = $('.js-eq-width'),
    maxWidth = 0;

  item.each(function () {
    let itemWidth = $(this).width(),
      spacer;
    if (maxWidth < itemWidth) {
      $(this).width(itemWidth);
      maxWidth = itemWidth;
    } else {
      $(this).width(maxWidth);
    }

    spacer = maxWidth + 'px';
    if (!$(this).find('div').length) {
      $(`<div style="width:${spacer}"></div>`).appendTo($(this));
    }
  });
};
$(document).ready(function () {
  if ($('.js-eq-width').length) {
    equalWidth();
  }
});
$(window).on('resize orientationchange', function () {
  if ($('.js-eq-width').length) {
    equalWidth();
  }
});
